import {Grid} from '@mui/material';
import {
  NON_PARTICIPATING_OUTLET_LABEL,
  TRANSACTION_TYPES,
  TRANSACTION_TYPES_BONUS_POINTS_LABELS,
  TRANSACTION_TYPES_CONSTANTS,
} from '../../constants/transaction';
import colors from '../../theme/colors';
import {formatTemplate} from '../../utils/helpers';
import {Typography} from './AllTransaction.style';

export const DEFAULT_FILTER_PAGE_SIZE = 10;

export const DISPLAY_MODE_CONSTANTS = {
  TEST: 'true',
  LIVE: 'false',
  ALL: 'none',
};

export const DISPLAY_MODE_LABELS = {
  [DISPLAY_MODE_CONSTANTS.ALL]: 'All',
  [DISPLAY_MODE_CONSTANTS.LIVE]: 'Live mode',
  [DISPLAY_MODE_CONSTANTS.TEST]: 'Test mode (Internal test)',
};

export const DISPLAY_MODE_LABEL_FOR_PILLS = {
  [DISPLAY_MODE_CONSTANTS.ALL]: 'Display mode - All',
};

export const POINT_STATUS_CONSTANTS = {
  POSITIVE: 1,
  NEGATIVE: 2,
};

export const EXCESS_REDEMPTION_AMOUNT_CONSTANTS = {
  EQUAL_0: 'eq_0',
  GREATER_THAN_0: 'gt_0',
};

export const EXCESS_REDEMPTION_AMOUNT_OPTIONS = {
  [EXCESS_REDEMPTION_AMOUNT_CONSTANTS.EQUAL_0]: 'No excess',
  [EXCESS_REDEMPTION_AMOUNT_CONSTANTS.GREATER_THAN_0]: 'Excess only',
};

export const HIGHLIGHTED_GROUP_COLOR = colors.grey[300];

export const renderTransactionTypeLabel = (dataDetail: any) => {
  const transactionType = dataDetail?.transactionType;
  const config = {
    defaultFallbackValueByPath: '--',
    ...(transactionType === TRANSACTION_TYPES_CONSTANTS.EARN_POINTS_VIA_RECEIPT
      ? {
          fallbackValuesByPath: {
            islandPartnerName: NON_PARTICIPATING_OUTLET_LABEL.toLowerCase(),
          },
        }
      : {}),
  };
  const transactionTypeString = formatTemplate(
    TRANSACTION_TYPES[transactionType],
    dataDetail,
    '--',
    config
  );

  return transactionTypeString.replace(/, $/, '');
};

export const renderTransactionTypeBonusPointsLabel = (dataDetail: any) => {
  const transactionType = dataDetail?.transactionType;
  const transactionTypeString = formatTemplate(
    TRANSACTION_TYPES_BONUS_POINTS_LABELS[transactionType],
    dataDetail,
    '',
    {
      defaultFallbackValueByPath: '--',
    }
  );
  return transactionTypeString.replace(/, $/, '');
};

export const renderTransactionType = (
  dataDetail: any,
  isDetailPage = false
) => {
  const transactionTypeLabel = renderTransactionTypeLabel(dataDetail);
  const transactionTypeBonusPointsLabel =
    renderTransactionTypeBonusPointsLabel(dataDetail);

  if (transactionTypeBonusPointsLabel) {
    return (
      <Grid container direction="column" spacing={1}>
        <Grid item>{transactionTypeLabel}</Grid>
        <Grid item>
          {isDetailPage === false && (
            <Typography fontWeight="bolder">
              {transactionTypeBonusPointsLabel}
            </Typography>
          )}
          {isDetailPage !== false ? transactionTypeBonusPointsLabel : null}
        </Grid>
      </Grid>
    );
  }

  return transactionTypeLabel;
};

export const renderRedemptionAmount = (dataDetail: any) => {
  if (
    [
      TRANSACTION_TYPES_CONSTANTS.ISLANDER_POINTS_REDEMPTION,
      TRANSACTION_TYPES_CONSTANTS.USE_VOUCHERS,
    ].includes(dataDetail?.transactionType) &&
    dataDetail?.redemptionAmount !== null &&
    !isNaN(dataDetail?.redemptionAmount)
  ) {
    return parseFloat(dataDetail.redemptionAmount).toFixed(2);
  }

  return '--';
};
